import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledOverflowContainer = styled(Box)(({}) => ({
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
